import { appConstants } from "../../action-constants/inapp.constants";

// Get Customer Details Reducer
export const getCustomerDetailsReducer = (state = {}, action: any) => {
    switch (action.type) {
        case appConstants.GET_CUSTOMER_DETAILS_PENDING:
            return { loading: true };
        case appConstants.GET_CUSTOMER_DETAILS_SUCCESS:
            return { data: action.response.data, loading: false };
        case appConstants.GET_CUSTOMER_DETAILS_FAILURE:
            return { error: action.error, loading: false };
        case appConstants.GET_CUSTOMER_DETAILS_RESET:
            return {};
        default:
            return state;
    }
};

// Update Customer Reducer
export const updateCustomerReducer = (state = {}, action: any) => {
    switch (action.type) {
        case appConstants.UPDATE_CUSTOMER_PENDING:
            return { loading: true };
        case appConstants.UPDATE_CUSTOMER_SUCCESS:
            return { data: action.response, loading: false, success: true };
        case appConstants.UPDATE_CUSTOMER_FAILURE:
            return { error: action.error, loading: false };
        case appConstants.UPDATE_CUSTOMER_RESET:
            return {};
        default:
            return state;
    }
};

// Get Customer Orders Reducer
export const getCustomerOrdersReducer = (state = {}, action: any) => {
    switch (action.type) {
        case appConstants.GET_CUSTOMER_ORDERS_PENDING:
            return { loading: true };
        case appConstants.GET_CUSTOMER_ORDERS_SUCCESS:
            return { data: action.response.data, loading: false };
        case appConstants.GET_CUSTOMER_ORDERS_FAILURE:
            return { error: action.error, loading: false };
        case appConstants.GET_CUSTOMER_ORDERS_RESET:
            return {};
        default:
            return state;
    }
};

// Get Customer Total Spent Reducer
export const getCustomerTotalSpentReducer = (state = {}, action: any) => {
    switch (action.type) {
        case appConstants.GET_CUSTOMER_TOTAL_SPENT_PENDING:
            return { loading: true };
        case appConstants.GET_CUSTOMER_TOTAL_SPENT_SUCCESS:
            return { data: action.response.data, loading: false };
        case appConstants.GET_CUSTOMER_TOTAL_SPENT_FAILURE:
            return { error: action.error, loading: false };
        case appConstants.GET_CUSTOMER_TOTAL_SPENT_RESET:
            return {};
        default:
            return state;
    }
};

// Get Customer Stores Reducer
export const getCustomerStoresReducer = (state = {}, action: any) => {
    switch (action.type) {
        case appConstants.GET_CUSTOMER_STORES_PENDING:
            return { loading: true };
        case appConstants.GET_CUSTOMER_STORES_SUCCESS:
            return { data: action.response.data, loading: false };
        case appConstants.GET_CUSTOMER_STORES_FAILURE:
            return { error: action.error, loading: false };
        case appConstants.GET_CUSTOMER_STORES_RESET:
            return {};
        default:
            return state;
    }
};
